/**
 * 此文件中有较多冗余代码
 * 以及部分需按需引入的方法具体见注释
 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import isViewButton from "./utils/menu/ViewButton"; //查看列表页面增删改查
import dateFormat from "./utils/menu/dateFormat"; //时间处理Y + M + D + h + m + s; 一期项目方法  二期已具优化为按需导入 具体使用见新页面中的使用方式
import dateFormatDay from "./utils/menu/dateFormatDay"; //时间处理Y + M + D;  一期项目方法  二期已具优化为按需导入 具体使用见新页面中的使用方式
// import VueResource from "vue-resource"; // 不推荐使用  vue 中推荐使用的是 axios
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/icon.css";
import "./assets/css/main.css";
import "./assets/css/color-dark.css"; /*深色主题*/
import tableWidth from "./utils/jsonData/tableWidth"; // 查看列表页面增删改查
/*//自己写的样式
import './style/theme.css'
import './style/character.css'*/
import store from "./store";
import axios from "@/utils/request.js"; //导入axios
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "babel-polyfill";
import plugin from "@/plugin"; //
import get_cell_style from "./utils/tableStyle"; // 处理table的列内设置宽度和悬浮显示时不兼容问题
import { VueJsonp } from 'vue-jsonp'
import * as echarts from "echarts";


Vue.use(VueJsonp)
Vue.use(plugin);
Vue.use(VueQuillEditor);
Vue.prototype.$tableWidth = tableWidth; // 列宽公共的方法 二期

Vue.prototype.$echarts = echarts;
Vue.prototype.$get_cell_style = get_cell_style; // 处理悬浮提示和设置列宽的不兼容
Vue.prototype.$isViewButton = isViewButton;
Vue.prototype.$dateFormat = dateFormat; // 挂载到vue示例上的时间处理方法
Vue.prototype.$dateFormatDay = dateFormatDay;

// Vue.prototype.$echarts = echarts
Vue.prototype.$axios = axios; //修改原始数据
Vue.config.devtools = true; //生产环境中需要设置为false
Vue.config.productionTip = false; //阻止vue启动时生成生产消息
Vue.config.silent = true; //静默(取消)日志与警告提醒
// axios.defaults.headers.get['Content-Type'] = contentType //阻止启动生产消息，常用作指令
// 注册element-ui
// Vue.use(ElementUI);
Vue.use(ElementUI, {
    size: 'mini' // set element-ui default size
})
Vue.directive('focus', {
        inserted(el, binding, vnode) {
            if (el.querySelector('input')) {
                el.querySelector('input').focus();
            }
        }
    })
    /**
     * 请求拦截的封装
     * 以下为一期封装axios
     * @/utils/request文件为二期封装文件，使用示例见api/api_ports_v2文件夹内
     */

//Vue.prototype.$httpStr = "http://jfstatic.seatopia.cn/";
//Vue.prototype.$httpMapIp = "http://jfstatic.seatopia.cn/";
//axios.defaults.baseURL = "https://jf.seatopia.cn"

//Vue.prototype.$httpStr = "http://8.140.236.195:8081/";
//Vue.prototype.$httpMapIp = "http://8.140.236.195:8081/";
//axios.defaults.baseURL = "http://8.140.236.195:8081/"

Vue.prototype.$httpStr = "https://static.qhdjf.cn/";
Vue.prototype.$httpMapIp = "https://static.qhdjf.cn/";
axios.defaults.baseURL = "https://api-admin.qhdjf.cn/";


Vue.prototype.$http = axios;

var app = new Vue({
    el: "#app",
    store,
    router,
    render: h => h(App)
});